let envBaseUrl: string = 'https://nutribackend.staging.zsolution.vn'
let envBasePOSUrl: string = 'https://nutripos.staging.zsolution.vn/'
let envBaseErpUrl: string = 'https://erp-stg.zholding.vn'

switch (process.env.REACT_APP_APP_MODE) {
  case "development":
    envBaseUrl = 'https://nutribackend.staging.zsolution.vn';
    envBasePOSUrl = 'https://nutripos.staging.zsolution.vn/';
    envBaseErpUrl = 'https://erp-stg.zholding.vn';
    break;
  case "production":
    envBaseUrl = 'https://nutribackend.zsolution.vn';
    envBasePOSUrl = 'https://nutripos.zsolution.vn/';
    envBaseErpUrl = 'https://erp.zholding.vn';
    break;
  case "localhost":
    envBaseUrl = 'http://localhost:3000';
    envBasePOSUrl = 'https://nutripos.staging.zsolution.vn/';
    envBaseErpUrl = 'https://erp-stg.zholding.vn';
    break;
  default:
    break;
}
export const baseUrl = envBaseUrl;
export const basePOSUrl = envBasePOSUrl;
export const baseErpUrl = envBaseErpUrl;

export const firebaseConfig = {
  apiKey: "AIzaSyCVLC9abb5fvUQ_hpGYm9iwfcDFkgofrpw",
  authDomain: "zs-drnutri.firebaseapp.com",
  projectId: "zs-drnutri",
  storageBucket: "zs-drnutri.appspot.com",
  messagingSenderId: "623469369454",
  appId: "1:623469369454:web:00ac14ee838cbd1f342e7f",
  measurementId: "G-YNQ47LWHKF"
};

export const payment_method = {
  atm_id: process.env.REACT_APP_APP_MODE === 'development' ? 15 : 7,
  transfer_id: process.env.REACT_APP_APP_MODE === 'development' ? 3 : 8,
  cash_id: process.env.REACT_APP_APP_MODE === 'development' ? 9 : 9,
  vnpay_qr_id: process.env.REACT_APP_APP_MODE === 'development' ? 8 : 11,
  vnpay_spos_id: process.env.REACT_APP_APP_MODE === 'development' ? 7 : 10
}
